import React from 'react';
import { CellRendererSelectorFunc } from 'ag-grid-community';

function RelatedDocumentIconDisabled() {
  return (
    <div
      style={{
        color: '#d5d5d5',
        display: 'flex',
        height: '100%',
        alignItems: 'center',
      }}
    >
      <span className="ag-icon ag-icon-tree-closed" />
    </div>
  );
}

const renderRelatedDocumentIcon: CellRendererSelectorFunc = (params) => {
  if (!params.value) {
    return {
      component: RelatedDocumentIconDisabled,
    };
  }

  return {
    component: 'agGroupCellRenderer',
  };
};

export default renderRelatedDocumentIcon;
